export default __webpack_public_path__ + "static/media/single-pringle.1e801926.svg";